import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ProjectCategory} from "../../../models/project-category.model";
import {Subscription} from "rxjs";
import {MatTableDataSource} from "@angular/material/table";
import {MatSort} from "@angular/material/sort";
import {MatPaginator} from "@angular/material/paginator";
import {Router} from "@angular/router";
import {DemokratiewerkstattCategory} from "../../../models/demokratiewerkstatt.model";
import {DemokratiewerkstattCategoryService} from "../../../services/demokratiewerkstatt-category.service";

@Component({
    selector: 'app-demokratiewerkstatt-category-list',
    templateUrl: './demokratiewerkstatt-category-list.component.html',
    styleUrls: ['./demokratiewerkstatt-category-list.component.css']
})
export class DemokratiewerkstattCategoryListComponent implements OnInit, OnDestroy {

    public showSpinner: boolean = true;
    public displayedColumns: string[] = ['position', 'name', 'description', 'edit', 'delete'];
    public dataSource: MatTableDataSource<DemokratiewerkstattCategory>;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    protected demokratiewerkstattCategories: DemokratiewerkstattCategory[] = [];
    protected demokratiewerkstattCategorySubscription$: Subscription;

    constructor(
        private readonly _demokratiewerkstattCategoryService: DemokratiewerkstattCategoryService,
        private readonly _router: Router
    ) {
    }

    ngOnInit(): void {
        this._demokratiewerkstattCategoryService.getAllCategorys();
        window.scrollTo(0, 0);
        this.demokratiewerkstattCategorySubscription$ = this._demokratiewerkstattCategoryService.DemokratiewerkstattCategorySubject.subscribe(
            (response: DemokratiewerkstattCategory[]) => {
                this.demokratiewerkstattCategories = response;
                this.demokratiewerkstattCategories = [...this.demokratiewerkstattCategories.map(x => JSON.parse(JSON.stringify(x)))];
                this.demokratiewerkstattCategories = this.demokratiewerkstattCategories.map(demokratiewerkstattCategory => {
                    if (demokratiewerkstattCategory.description) {
                        let subDes = demokratiewerkstattCategory.description.replace(/<(.+?)>/g, '');
                        if (subDes.length > 40) {
                            subDes = subDes.substring(0, 40);
                            subDes = subDes.substring(0, subDes.lastIndexOf(' '));
                            subDes += '...';
                        }
                        demokratiewerkstattCategory.description = subDes;
                    }
                    return demokratiewerkstattCategory;
                });
                this.showSpinner = false;
                this.dataSource = new MatTableDataSource(this.demokratiewerkstattCategories);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
            },
            (error) => {
                console.log('An error occured: ' + error);
            }
        );
    }

    public applyFilter(event: Event): void {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }

    public deleteCategory(demokratiewerkstattCategory: DemokratiewerkstattCategory): void {
        this._demokratiewerkstattCategoryService.deleteProjectCategory(demokratiewerkstattCategory.id ?? 0).subscribe(
            (response) => {
                this._demokratiewerkstattCategoryService.getAllCategorys();
                this._router.navigate(['/demokratiewerkstatt-category/list']);
            }
        );
    }

    ngOnDestroy(): void {
        this.demokratiewerkstattCategorySubscription$.unsubscribe();
    }
}
